import { AttendanceFilterOptionValue, FilterKey } from '@studyportals/search-filters';
import { FilterOptionInformation } from '@studyportals/search-filters';
import { FilterOptionsBase } from './FilterOptionsBase';
import { DeliveryMethodEnum } from '@studyportals/search-api-interface';

export class AttendanceOptions extends FilterOptionsBase {
	public override getFilterKey(): FilterKey {
		return FilterKey.DELIVERY_METHOD;
	}

	public override createOptions(): FilterOptionInformation[] {
		return [
			new FilterOptionInformation('On Campus Learning', AttendanceFilterOptionValue.FACE_2_FACE, '', '', 'On Campus'),
			new FilterOptionInformation('Online Learning', AttendanceFilterOptionValue.ONLINE, 'online', 'Online', 'Online'),
			new FilterOptionInformation('Blended Learning', AttendanceFilterOptionValue.BLENDED, '', '', 'Blended'),
		];
	}

	public static toEnum(value: string): DeliveryMethodEnum {
		switch (value) {
			case AttendanceFilterOptionValue.FACE_2_FACE:
				return DeliveryMethodEnum.ON_CAMPUS;
			case AttendanceFilterOptionValue.ONLINE:
				return DeliveryMethodEnum.ONLINE;
			case AttendanceFilterOptionValue.BLENDED:
				return DeliveryMethodEnum.BLENDED;
			default:
				throw new Error(`Unknown attendance value: ${value}`);
		}
	}
}
